import { render, staticRenderFns } from "./BalanceDetails.vue?vue&type=template&id=f116fd76"
import script from "./BalanceDetails.vue?vue&type=script&lang=js"
export * from "./BalanceDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports